import { render, staticRenderFns } from "./ScrollIndicator.vue?vue&type=template&id=ef0d0f46&scoped=true&lang=html&"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js&"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ScrollIndicator.vue?vue&type=style&index=0&id=ef0d0f46&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0d0f46",
  null
  
)

export default component.exports